import MedicalApp from './MedicalApp';
import MedicalsApp from './MedicalsApp';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const MedicalsAppConfig = {
    auth: [...authRoles.cc, ...authRoles.admin], //  ['cc']
    routes: [
        {
            path: '/apps/medical/:id',
            component: MedicalApp
        },
        {
            path: '/apps/medical',
            component: MedicalsApp
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/callHelper/medical/MedicalsAppConfig.js